import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('RentalExtraModel')
export default class RentalExtraModel {
  @JsonProperty('name', String) name:string = undefined;
  @JsonProperty('amount_selected', Number) amountSelected:number = -1;
}
